window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 3,
      mobileShow = 2,
      sliderGrid = "column",
      sliderAutoplay = e.dataset.autoplay,
      autoPlayValue = false,
      autoPlayTime = parseInt(e.dataset.autoplayTime),
      rowGap = Number(e.dataset.rowSpace) || 30;

    if (!window.Swiper) {
      return;
    }

    if (sliderAutoplay == "true") {
      autoPlayValue = {
        delay: autoPlayTime,
      };
    }

    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      const extraLargeAttr = parseFloat(e.dataset.showExtraLarge);
      const largeAttr = parseFloat(e.dataset.showLarge);
      const tabletAttr = parseFloat(e.dataset.showTablet);
      const mobileAttr = parseFloat(e.dataset.showMobile);

      if (!Number.isNaN(extraLargeAttr)) {
        extraLargeDesktopShow = extraLargeAttr;
      }

      if (!Number.isNaN(largeAttr)) {
        largeDesktopShow = largeAttr;
      }

      if (!Number.isNaN(tabletAttr)) {
        tabletShow = tabletAttr;
      }

      if (!Number.isNaN(mobileAttr)) {
        mobileShow = mobileAttr;
      }

    } else {
      sliderContainer = false;
    }

    if (!sliderContainer) {
      return;
    }

    const slides = sliderContainer.querySelectorAll(".swiper-slide");
    const slidesCount = slides.length;

    if (!slidesCount) {
      return;
    }

    if (Number.isNaN(mobileShow) || mobileShow < 1) {
      mobileShow = 1;
    }

    if (Number.isNaN(largeDesktopShow) || largeDesktopShow < 1) {
      largeDesktopShow = 1;
    }

    if (Number.isNaN(extraLargeDesktopShow) || extraLargeDesktopShow < 1) {
      extraLargeDesktopShow = 1;
    }

    const maxSlidesPerView = Math.max(
      mobileShow,
      largeDesktopShow,
      extraLargeDesktopShow
    );

    mobileShow = Math.min(mobileShow, slidesCount);
    largeDesktopShow = Math.min(largeDesktopShow, slidesCount);
    extraLargeDesktopShow = Math.min(extraLargeDesktopShow, slidesCount);

    let sliderLoop = slidesCount > maxSlidesPerView;
    if (typeof e.dataset.loop !== "undefined") {
      if (e.dataset.loop === "false" || e.dataset.loop === "0") {
        sliderLoop = false;
      } else if (e.dataset.loop === "true" || e.dataset.loop === "1") {
        sliderLoop = slidesCount > maxSlidesPerView;
      }
    }

    if (slidesCount <= maxSlidesPerView) {
      autoPlayValue = false;
    }

    var featuredCollection = new Swiper(sliderContainer, {
      loop: sliderLoop,
      autoHeight: e.dataset.autoHeight === "true",
      slidesPerView: mobileShow,
      spaceBetween: 20,
      slidesPerGroup: 1,
      autoplay: autoPlayValue,
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        clickable: true,
        type: "fraction",
      },
      navigation: {
        nextEl: e.querySelector(".swiper-button-next"),
        prevEl: e.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: mobileShow,
          spaceBetween: 20
        },
        750: {
          slidesPerView: largeDesktopShow,
          spaceBetween: 20
        },
        992: {
          slidesPerView: extraLargeDesktopShow,
          spaceBetween: 20
        },
        1200: {
          slidesPerView: extraLargeDesktopShow,
          spaceBetween: rowGap
        },
      },
    });

    if (sliderContainer && autoPlayValue) {
      sliderContainer.addEventListener("mouseenter", (e) => {
        featuredCollection.autoplay.stop();
      });
      sliderContainer.addEventListener("mouseleave", (e) => {
        featuredCollection.autoplay.start();
      });
    }
  }
  return sliderProduct;
})();

document.addEventListener("DOMContentLoaded", function () {
  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerCartModule = new theme.Sections(),
    headerStickyModule = new theme.Sections(),
    headerMainMenu = new theme.Sections();
  headerMainMenuSlider = new theme.Sections();

  sections.register("scrolling_bar", theme.scrollingText);
  sections.register("header", theme.headerSection);
  headerMainMenuSlider.register("header", theme.menuProductSlider);
  headerSearchModule.register("header", theme.headerSearch);
  headerCartModule.register("header", theme.CartDrawerActions);
  headerStickyModule.register("header", theme.headerSticky);
  headerMainMenu.register("header", theme.headerMainMenuModule);
  sections.register("footer", theme.footerSection);
  sections.register("slideShow", theme.SlideShow);
  sections.register("collection-product", theme.collectionProduct);
  sections.register("product-slider", theme.collectionSlider);
  sections.register("accordion", theme.accordion);
  sections.register("blog", theme.blog);
});
